import PropTypes from 'prop-types';
import clsx from 'clsx';

const baseStyles =
  'workspace-button flex items-center gap-2 rounded-md border px-4 py-2 font-command-label text-xs uppercase tracking-widest transition-colors';
const defaultColorStyles = 'workspace-button--primary';
const hoverStyles = '';
const disabledStyles = 'workspace-button--disabled';

const ButtonComponent = ({
  children,
  className = '',
  customColorsStyles = '',
  disabled = false,
  ...props
}) => {
  const colorClasses = disabled ? disabledStyles : customColorsStyles || defaultColorStyles;

  const classNameButton = clsx(baseStyles, !disabled && hoverStyles, colorClasses, className);

  return (
    <button className={classNameButton} disabled={disabled} {...props}>
      {children}
    </button>
  );
};

ButtonComponent.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  customColorsStyles: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  onClick: PropTypes.func
};

ButtonComponent.defaultProps = {
  className: '',
  customColorsStyles: '',
  disabled: false,
  type: 'button'
};

export default ButtonComponent;
